import React from 'react'
import notFoundImage from './not-found.svg'
import { CenterScreen, HorizontalStack, IconValueBlock } from '@ztechapps/webui.util'
export const PageLayoutNotFound = () => {
  return (
    <CenterScreen>
      <HorizontalStack className="justify-content-center">
        <div>
          <h1>404</h1>
          <h4>The page you are looking for doesn't exist.</h4>

          <div>
            <a className="btn  btn-primary  " href="/">
              <IconValueBlock icon="home" value="Back to Home" />
            </a>
          </div>
        </div>
        <div>
          <img src={notFoundImage} className="img-fluid py-5" alt="Page Not Found" />
        </div>
      </HorizontalStack>
    </CenterScreen>
  )
}
